// import React from "react";
// import {
//   BedDouble,
//   Mail,
//   MapPin,
//   Ruler,
// } from "lucide-react"; /*  npm i lucide-react  */

// export default function RealEstate() {
//   const listings = [
//     {
//       id: 1,
//       title: "Modern Family Villa",
//       location: "Beverly Hills, CA",
//       price: "$4,250,000",
//       beds: 5,
//       area: 5800,
//       image:
//         "https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/88e63e42489939.57ce6aaccd2dc.jpg",
//     },
//     {
//       id: 2,
//       title: "Skyline Penthouse",
//       location: "Manhattan, NY",
//       price: "$8,750,000",
//       beds: 4,
//       area: 4200,
//       image:
//         "https://cdn.asiatatler.com/asiatatler/hk/i/2017/11/story/29143/14142904-GladdenPrivateIsland_resized_1920x1280.jpg",
//     },
//     {
//       id: 3,
//       title: "Coastal Retreat",
//       location: "Maui, HI",
//       price: "$3,980,000",
//       beds: 3,
//       area: 3600,
//       image:
//         "https://images.unsplash.com/photo-1507086186004-81e0abddd3ee?auto=format&fit=crop&w=1200&q=80",
//     },
//   ];

//   return (
//     <main className="font-sans text-gray-800">
//       {/* ─────────────────  Hero  ───────────────── */}
//       <section
//         className="relative flex items-center justify-center h-[80vh]"
//         style={{
//           backgroundImage:
//             "url(https://images.unsplash.com/photo-1600585154356-596af9009e82?auto=format&fit=crop&w=1600&q=80)",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div className="absolute inset-0 bg-black/60" />
//         <div className="relative z-10 text-center px-4">
//           <h1 className="text-4xl md:text-6xl font-bold text-white">
//             Find Your Dream Home
//           </h1>
//           <p className="mt-4 text-lg md:text-2xl text-gray-200">
//             Luxury estates & budget‑friendly homes worldwide.
//           </p>
//           <a
//             href="#listings"
//             className="inline-block mt-6 bg-white text-black px-8 py-3 rounded-lg font-medium hover:bg-rose-600 hover:text-white transition"
//           >
//             Browse Listings
//           </a>
//         </div>
//       </section>

//       {/* ─────────────── Featured Listings ─────────────── */}
//       <section id="listings" className="py-16 bg-gray-50">
//         <div className="max-w-6xl mx-auto px-4">
//           <h2 className="text-3xl font-semibold text-center mb-10">
//             Featured Listings
//           </h2>
//           <div className="grid gap-8 md:grid-cols-3">
//             {listings.map((home) => (
//               <article
//                 key={home.id}
//                 className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition"
//               >
//                 <img
//                   src={home.image}
//                   alt={home.title}
//                   className="w-full h-60 object-cover"
//                 />
//                 <div className="p-6 space-y-2">
//                   <h3 className="text-xl font-semibold">{home.title}</h3>
//                   <p className="flex items-center gap-1 text-sm text-gray-500">
//                     <MapPin className="h-4 w-4" /> {home.location}
//                   </p>
//                   <p className="text-rose-600 font-bold">{home.price}</p>
//                   <div className="flex items-center justify-between text-sm text-gray-600">
//                     <span className="flex items-center gap-1">
//                       <BedDouble className="h-4 w-4" />
//                       {home.beds} Beds
//                     </span>
//                     <span className="flex items-center gap-1">
//                       <Ruler className="h-4 w-4" />
//                       {home.area.toLocaleString()} sqft
//                     </span>
//                   </div>
//                 </div>
//               </article>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ─────────────────── About ─────────────────── */}
//       <section className="py-16">
//         <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 gap-10 items-center">
//           <img
//             src="https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80"
//             alt="Real Estate agents"
//             className="rounded-2xl shadow-lg object-cover"
//           />
//           <div>
//             <h2 className="text-3xl font-semibold mb-4">About Regal Realty</h2>
//             <p className="text-gray-600 leading-relaxed">
//               Since 2008, Regal Realty has connected discerning buyers with
//               premier properties across the globe. Our award‑winning agents
//               combine deep market knowledge with a client‑first approach.
//             </p>
//             <ul className="mt-6 space-y-3 text-gray-700">
//               <li>🏆 1,200+ properties sold</li>
//               <li>🌐 Offices in 6 countries</li>
//               <li>🤝 98% client satisfaction rate</li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* ──────────────── Contact CTA ──────────────── */}
//       <section className="bg-rose-600 text-white py-16">
//         <div className="max-w-3xl mx-auto px-4 text-center">
//           <h2 className="text-3xl font-semibold">Ready to schedule a visit?</h2>
//           <p className="mt-2 mb-6">
//             Our agents are available 7 days a week to guide you.
//           </p>
//           <a
//             href="mailto:hello@regalrealty.com"
//             className="inline-flex items-center gap-2 bg-white text-rose-600 font-medium px-8 py-3 rounded-lg hover:bg-gray-100 transition"
//           >
//             <Mail className="h-5 w-5" />
//             Contact Us
//           </a>
//         </div>
//       </section>
//     </main>
//   );
// }

"use client";

import React, { useEffect } from "react";
import {
  BedDouble,
  Mail,
  MapPin,
  Ruler,
  Home,
  Eye,
  UserCheck,
} from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

export default function RealEstate() {
  // useEffect(() => {
  //   AOS.init({ duration: 800, once: true });
  // }, []);

  const listings = [
    {
      id: 1,
      title: "Modern Family Villa",
      location: "Beverly Hills, CA",
      price: "$4,250,000",
      beds: 5,
      area: 5800,
      image:
        "https://i.pinimg.com/736x/1f/33/cc/1f33ccb3165a1123685d8474b3e1052c.jpg",
    },
    {
      id: 2,
      title: "Skyline Penthouse",
      location: "Manhattan, NY",
      price: "$8,750,000",
      beds: 4,
      area: 4200,
      image:
        "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1200&q=80",
    },
    {
      id: 3,
      title: "Coastal Retreat",
      location: "Maui, HI",
      price: "$3,980,000",
      beds: 3,
      area: 3600,
      image:
        "https://i.pinimg.com/736x/8f/52/cf/8f52cfdfe8347be6458410aa169ec2f0.jpg",
    },
  ];

  return (
    <main className="font-sans text-gray-800 overflow-hidden">
      {/* ───────── Hero Section ───────── */}
      <section
        className="relative flex items-center justify-center h-[50vh]"
        style={{
          backgroundImage:
            "url(https://i.pinimg.com/736x/02/13/67/0213675ac19355c6d19eacb0e580e3b9.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div
          className="relative z-10 text-center px-4"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h1 className="text-4xl md:text-6xl font-bold text-white">
            Find Your Dream Home
          </h1>
          <p className="mt-4 text-lg md:text-2xl text-gray-200">
            Luxury estates & budget‑friendly homes worldwide.
          </p>
          {/* <a
            href=""
            className="inline-block mt-6 bg-white text-black px-8 py-3 rounded-lg font-medium hover:bg-rose-600 hover:text-white transition"
          >
            Browse Listings
          </a> */}
        </div>
      </section>

      {/* ───────── About Section ───────── */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 gap-10 items-center">
          <img
            data-aos="fade-right"
            src="https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80"
            alt="Real Estate agents"
            className="rounded-2xl shadow-lg object-cover"
          />
          <div data-aos="fade-left">
            <div className="inline-block">
              <h2 className="text-3xl font-semibold mb-2 text-blue-700">
                About Regal Realty
              </h2>
              <div className="h-1 w-32 bg-[#6FEF34] mx-auto mb-4 blink-underline"></div>
            </div>

            <p className="text-gray-600 leading-relaxed">
              Since 2008, Regal Realty has connected discerning buyers with
              premier properties across the globe. Our award‑winning agents
              combine deep market knowledge with a client‑first approach.
            </p>
            <ul className="mt-6 space-y-3 text-gray-700">
              <li>🏆 1,200+ properties sold</li>
              <li>🌐 Offices in 6 countries</li>
              <li>🤝 98% client satisfaction rate</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ───────── Listings Section ───────── */}
      <section id="listings" className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-10" data-aos="fade-up">
            <h2 className="text-3xl font-semibold mb-2 text-blue-700 blink-underline">
              Featured Listings
            </h2>
            <div className="h-1 w-32 bg-[#6FEF34] mx-auto"></div>
          </div>

          <div className="grid gap-8 md:grid-cols-3">
            {listings.map((home, index) => (
              <article
                key={home.id}
                data-aos="zoom-in"
                data-aos-delay={index * 100}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition"
              >
                <img
                  src={home.image}
                  alt={home.title}
                  className="w-full h-60 object-cover"
                />
                <div className="p-6 space-y-2">
                  <h3 className="text-xl font-semibold">{home.title}</h3>
                  <p className="flex items-center gap-1 text-sm text-gray-500">
                    <MapPin className="h-4 w-4" /> {home.location}
                  </p>
                  <p className="text-rose-600 font-bold">{home.price}</p>
                  <div className="flex items-center justify-between text-sm text-gray-600">
                    <span className="flex items-center gap-1">
                      <BedDouble className="h-4 w-4" />
                      {home.beds} Beds
                    </span>
                    <span className="flex items-center gap-1">
                      <Ruler className="h-4 w-4" />
                      {home.area.toLocaleString()} sqft
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ───────── Cards Section ───────── */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-10" data-aos="fade-up">
            <h2 className="text-3xl font-semibold mb-2 text-blue-700">
              Why Choose Regal Realty?
            </h2>
            <div className="h-1 w-32 bg-[#6FEF34] mx-auto blink-underline"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div
              className="bg-gray-100 rounded-2xl p-6 text-center shadow hover:shadow-lg transition"
              data-aos="flip-left"
            >
              <Home className="h-10 w-10 mx-auto text-rose-600 mb-4" />
              <h4 className="text-xl font-semibold mb-2">
                Mortgage Assistance
              </h4>
              <p className="text-gray-600">
                We help you secure the best financing options to match your
                needs and budget.
              </p>
            </div>
            <div
              className="bg-gray-100 rounded-2xl p-6 text-center shadow hover:shadow-lg transition"
              data-aos="flip-up"
            >
              <Eye className="h-10 w-10 mx-auto text-rose-600 mb-4" />
              <h4 className="text-xl font-semibold mb-2">Virtual Tours</h4>
              <p className="text-gray-600">
                Explore properties online with 3D walkthroughs and video
                appointments.
              </p>
            </div>
            <div
              className="bg-gray-100 rounded-2xl p-6 text-center shadow hover:shadow-lg transition"
              data-aos="flip-right"
            >
              <UserCheck className="h-10 w-10 mx-auto text-rose-600 mb-4" />
              <h4 className="text-xl font-semibold mb-2">Trusted Agents</h4>
              <p className="text-gray-600">
                Our certified professionals ensure transparency, trust, and the
                best deals.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ───────── Contact Section ───────── */}
      <section className="bg-rose-600 text-white py-16" data-aos="fade-up">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-semibold">Ready to schedule a visit?</h2>
          <p className="mt-2 mb-6">
            Our agents are available 7 days a week to guide you.
          </p>
          {/* <a
            href="mailto:hello@regalrealty.com"
            className="inline-flex items-center gap-2 bg-white text-rose-600 font-medium px-8 py-3 rounded-lg hover:bg-gray-100 transition"
          >
            <Mail className="h-5 w-5" />
            Contact Us
          </a> */}
          <Link
            to="/contact"
            className="inline-flex items-center justify-center bg-white text-rose-600 font-medium px-8 py-3 rounded-lg hover:bg-gray-100 transition"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </main>
  );
}
